import { Button, Modal } from "react-bootstrap";
import React, { useState } from "react";
import { QRCode } from 'react-qrcode-logo';
import { useDispatch } from "react-redux";

import LogoIcon from './favicon.ico'
import { setQrCodeData } from "Manage/actions";

const QRCodeModal = ({onHide, show, domain,}) => {
    const [qrSize, setQrSize] = useState(300);
    const [logoSize, setLogoSize] = useState(qrSize / 2 / 2);
    const dispatch = useDispatch();

    const qrCanvasId = 'qr-code-canvas';

    const downloadQR = () => {
      const saveAsJpeg = true;
      let fileName = 'QR-Code';
      const canvas = document.getElementById(qrCanvasId) 
      if (saveAsJpeg) {
        try {
          const link = document.createElement('a');
  
          // Save as JPEG
          link.download = `${fileName}.jpeg`;
          link.href = canvas?.toDataURL('image/jpeg');
  
          // Trigger the download
          link.click();
        } catch (error) {
          console.error(error);
        }
      } else {
        try {
          const convertCanvasToSvg = () => {
            const serializer = new XMLSerializer();
            const canvasXml = serializer.serializeToString(canvas);
  
            const svgString = `
              <svg xmlns="http://www.w3.org/2000/svg" width="${canvas.width}" height="${canvas.height}">
                <foreignObject width="100%" height="100%">
                  <div xmlns="http://www.w3.org/1999/xhtml">
                    <style>
                      svg {
                        background-color: white;
                      }
                    </style>
                    ${canvasXml}
                  </div>
                </foreignObject>
              </svg>
            `;
            return svgString;
          };
  
          const svgString = convertCanvasToSvg();
          const blob = new Blob([svgString], {
            type: 'image/svg+xml;charset=utf-8',
          });
  
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
  
          URL.revokeObjectURL(link.href);
        } catch (error) {
          console.error(error);
        }
      }
    };
   
  const handlePrint = () => {
    const canvas = document.getElementById(qrCanvasId);
    if (canvas) {
      const printWindow = window.open('', '_blank');
      printWindow.document.write('<html><head><title>Print</title></head><body>');
      printWindow.document.write('<img src="' + canvas.toDataURL() + '" style="width: 100%;" />');
      printWindow.document.write('</body></html>');
      printWindow.document.close();
      printWindow.onload = () => {
          printWindow.print();
          printWindow.close();
      };
    }
  };

  const getDomain = (siteRecord) => {
    const subDomain = siteRecord?.subdomain;
    const domain = siteRecord || '';
    return subDomain || domain;
  };
    
  const onClose = () => {
    dispatch(setQrCodeData({}))
    onHide()
  }

  return <Modal
    show={show}
    onHide={onClose}
    aria-labelledby="contained-modal-title-vcenter"
    centered
  >
    <div className={`p-4 d-flex  align-items-center flex-column `}>
      <QRCode
        id={qrCanvasId}
        value={`https://${getDomain(domain)}`}
        size={qrSize}
        /*logoImage={LogoIcon}
        logoWidth={logoSize}
        logoHeight={logoSize}
        logoPadding={0}
        logoPaddingStyle={'circle'} // square | round
        removeQrCodeBehindLogo={true}*/
        eyeRadius={[
          { // top/left eye
              outer: [10, 10, 0, 10],
              inner: [0, 10, 10, 10],
          },
          [10, 10, 10, 0], // top/right eye
          [10, 0, 10, 10], // bottom/left
      ]}               eyeColor={'#6e2f9a'}
        qrStyle={'dots'} // squares | dots
        ecLevel={'H'} // L | M | Q | H
        fgColor={'#bc67ec'}
        quietZone={15}
      />

      <div className="mt-4 d-flex">
        <Button className="me-2 d-flex gap-2 align-items-center" variant="outline-primary" onClick={() => handlePrint()}>
        <img height="16" src="/assets/icons/print.svg"  alt="tooltip"/>
          Print
        </Button>
        <Button onClick={() => downloadQR()} className="me-2 d-flex gap-2 align-items-center"   >
        <img height="16" src="/assets/icons/download.svg"  alt="tooltip"/>
         Download
         </Button>
      </div>
    </div>
  </Modal>
}

export default QRCodeModal;